import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface EffectiveDateFormFieldProps {}

export const EffectiveDateFormField: React.FC<EffectiveDateFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ effective_date: string }>()

  return (
    <FormField
      name="effective_date"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center  gap-2">
              <FormLabel>Effective Date</FormLabel>
              <FormError />
            </div>
            <DatePicker
              placeholder={'Choose a date'}
              selected={value ? new Date(value) : undefined}
              onSelect={(date) =>
                date && setValue('effective_date', toISO8601(date), { shouldValidate: true })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
